import { StepLabel } from '@/theme/components';
import { styled } from '@/theme/index';

export const StyledStepLabel = styled(StepLabel)(({ theme }) => ({
  '.MuiStepLabel-labelContainer': {
    width: '50%',
    [theme.breakpoints.up('sm')]: {
      width: '100%',
    },
  },
}));
